// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YOGv","col":"styles_col__1eGH8"};